import { Component, OnInit,Input } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-comments-table',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit {
  @Input() comments: any = null;
  @Input() url: any = '';
  @Input() guid: any = '';
  current_user: any = null;

  comment: any = {
    reply_to: null,
    reply_to_text: null,
    comment: '',
    update: false
  }

  constructor(private globalService: GlobalService, private apiService: ApiService) { }

  ngOnInit() {
    this.GetCurrentUser();
  }

  async GetCurrentUser() {
    this.current_user = await this.globalService.GetUser();
  }

  //code for the comments
  //Create a comment and add it to the list
  async CreateComment() {
    let data: any = await this.apiService.post(`${this.url}/${this.guid}`,this.comment);
    if(data.success) {
      let comment_to_push = data.data[0];
      comment_to_push.users = [];
      comment_to_push.users.push({display_name:this.current_user.display_name});
      this.comments.push(comment_to_push);
      this.comment.comment = '';
      this.comment.reply_to = null;
      this.comment.reply_to_text = null;
    }
    this.globalService.presentToastMessage(data.message,data.success);
  }

  async UpdateComment() {
    let data: any = await this.apiService.put(`${this.url}/${this.comment.guid}`,this.comment);
    if(data.success) {

    }
    this.globalService.presentToastMessage(data.message,data.success);
  }

  //Setup the ability to reply
  async StartReplyTo(comment) {
    this.CancelCommentUpdate();
    this.comment.reply_to = comment.guid;
    this.comment.reply_to_name = comment.users[0].display_name;
    this.comment.reply_to_text = comment.comment;
  }

  //Cancel replying to a comment
  async CancelReply() {
    this.comment.reply_to = null;
    this.comment.reply_to_name = null;
    this.comment.reply_to_text = null;
  }

    
  async StartCommentUpdate(comment) {
    this.CancelReply();
    this.comment = comment;
    this.comment.update = true;
  }

    
  async CancelCommentUpdate() {
    this.comment.update = false;
    this.comment.comment = '';
  }

  async DeleteComment(comment) {
    let data: any = await this.apiService.delete(`${this.url}/${comment.guid}`,null);
    if (data.success) {
      var index = this.comments.findIndex(item => item.guid === comment.guid);
      this.comments.splice(index, 1);
    }
    this.globalService.presentToastMessage(data.message, data.success);
  }

}
